import React from 'react';
import { Captcha } from '@1c/ui';
import { useSearchParams } from 'src/utils/useSearchParams'
import { FinalField, FinalForm } from 'src/components/FinalForm';
import InputField from 'src/components/InputField';
import Button from 'src/components/Button';
import { inviteUserFormId } from '../constants';
import styles from './styles.module.scss';
import validate from './validate';

type Props = {
  captchaRef: React.RefObject<HTMLElement>;
  captchaError: string;
  onSubmit: (values: any) => void;
  isLoading: boolean;
  onClose: () => void;
};

const InviteUserForm: React.FC<Props> = ({ captchaRef, captchaError, onSubmit, isLoading, onClose }) => {
  const [searchParams] = useSearchParams();
  
  return (
    <FinalForm
      id={inviteUserFormId}
      onSubmit={onSubmit}
      submitting={isLoading}
      initialValues={{
        userEmail: searchParams.get('userEmail'),
        captcha: undefined,
    }}
      validate={validate}
      pristine
    >
      {({ submitting, pristine }: { submitting: any; pristine: any; }) => {
        return (
          <>
            <div className={styles['form']}>
              <FinalField name="userEmail">
                {({ value, onChange, error }: { value: any; onChange: any; error: string }) => (
                  <InputField
                    value={value}
                    onChange={onChange}
                    label="E-mail"
                    className={styles['input']}
                    error={error}
                  />
                )}
              </FinalField>
              <FinalField name="captcha">
                {({ onChange, error }: { onChange: any, error: string }) => {
                  const errorMessage = error || captchaError;
                  return (
                    <div className={styles['captcha-wrapper']}>
                      <Captcha ref={captchaRef} url="/ui/captcha/image.jpg" className={styles['captcha']}/>
                      <InputField
                        onChange={onChange}
                        className={styles['captcha-input']}
                        label="Введите символы с картинки"
                        error={errorMessage}
                      />
                    </div>
                  )
                }}
              </FinalField>
            </div>
            <div className={styles['buttons']}>
              <Button
                variant="outlined"
                disabled={submitting}
                onClick={onClose}
                className={styles['modal-button']}
              >
                Отмена
              </Button>
              <Button
                disabled={submitting || pristine}
                type="submit"
                form={inviteUserFormId}
                className={styles['modal-button']}
              >
                Отправить
              </Button>
            </div>
          </>
        );
      }}
    </FinalForm>
  );
};

export default InviteUserForm;
